import  React,{ useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from '@mui/material/Button';
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import Snackbar from "@mui/material/Snackbar";
import Clear from "@mui/icons-material/Clear";
import TablePagination from '@mui/material/TablePagination';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import moment from "moment";
import InfiniteScroll from "react-infinite-scroller";
import { setCache } from "../../../helpers/dataHelper";
import { useDispatch } from "react-redux";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";


let search_list = [];

const SavedSearchList = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;


  let From = state && state !== null ? state.isFrom : null;
  const [totalPage, setTotalPage] = useState(0);
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const [loading, setLoading] = useState(false);
  const [marketList, setMarketList] = useState([]);
  const [currentSearchId, setcurrentSearchId] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [openDialog, setOpenDialog] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [sortByCreatedDate, setSortByCreatedDate] = useState(false);
  const [sortBySearchName, setSortBySearchName] = useState(false);
  const [orderBy, setOrderBy] = useState("CreatedDate");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentSearchName, setCurrentSearchName] = useState("");
  const dispatch = useDispatch();
  const handleSortingByCreatedDate = (orderby, orderdirection) => { 
    search_list = [];
    setPage(1);
    setSortByCreatedDate(!sortByCreatedDate);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
  };

  const handleSortingBySearchName = (orderby, orderdirection) => {
    search_list = [];
    setPage(1);
    setSortBySearchName(!sortBySearchName);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
   };
  const fetchSearchList = (param) => {
     
    if (param === 1) {
      search_list = [];
      setPage(1);
    }
    setLoading(true);
    apiCommonTrigger("post",`${Config.API_URL}/search/savedsearches`, {
             "page": page,
        "resultsPerPage": rowsPerPage,
        "orderBy": orderBy,
        "orderDirection": orderDirection
          })
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          if(page===1){
          search_list=[res.data.searches];
          }else{
            search_list.push(res.data.searches);
          }
          setTotalPage(res.data.pagination?.totalpages);
          setSearchList(res.data.searches);
          setTotalRecords(res.data.pagination?.totalrecords);
        }
        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        setLoading(false);
        handlingCatchError(err, navigate);
      })
  };

  useEffect(() => { 
    if (location.state !== null) {
      search_list = [];
      navigate(location.pathname, {}); 
    }
    fetchSearchList();
  }, [rowsPerPage, orderDirection, orderBy, page]);

  const handleClickOpen = (e, search) => {
    setCurrentSearchName(search.searchname);
    setcurrentSearchId(search.id);
    setOpenDialog(true);
  };

  const handleClickClose = () => {
    setOpenDialog(false);
  };

  
  //snack bar open/close
  const snackHandleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };
  const handleDelete = () => {
  
    apiCommonTrigger("delete" , Config.API_URL + "/search/" , [currentSearchId])
      .then((res) => {
        if (res.status === 200) {
          setOpenDialog(false);
          setSnackOpen({
                 ...snack,
                 snackOpen: true,
                 snackMsg: "Search removed successfully!",
               });
          fetchSearchList(1);

        } 
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  }
  
  const handleInfiniteOnLoad = () => {
     
    // to avoid additional api hit
    if (page + 1 <= totalPage) {
      setPage(page + 1);
    }
   
  }
  return (
  <div className="common-table" >
       {loading ? (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      ) : null}
      <InfiniteScroll
        initialLoad={false}
        loadMore={handleInfiniteOnLoad}
        hasMore={page <= totalPage}
        threshold={20}
      >
      <h2>Saved Search</h2>
      <div className="my-markets-table saved_table">
      <TableContainer component={Paper} style={{ overflowX: "initial"}} className="table-design">
        <Table sx={{ minWidth: 650 }} aria-label="simple table"  stickyHeader>
          <TableHead>
            <TableRow>
            
              <TableCell align="left"> { sortBySearchName ? <span  onClick={() => handleSortingBySearchName("Searchname","DESC")}  style={{ cursor:"pointer", fontWeight : orderBy === 'Searchname' ? "bold" : ""}}>Search Name <ArrowDownwardOutlinedIcon fontSize="small" /></span> :<span onClick={() => handleSortingBySearchName("Searchname","ASC")} style={{ cursor:"pointer", fontWeight : orderBy === 'Searchname' ? "bold" : ""}}>Search Name<ArrowUpwardOutlinedIcon  fontSize="small"/></span>}</TableCell>
              <TableCell align="left">Keyword</TableCell>
              <TableCell align="left">Street</TableCell>
                  <TableCell>{sortByCreatedDate ? <span onClick={() => handleSortingByCreatedDate("CreatedDate", "DESC")} style={{ fontWeight : orderBy === "CreatedDate" ? "bold" : "" }}>Created Date <ArrowDownwardOutlinedIcon fontSize="small" /></span> : <span onClick={() => handleSortingByCreatedDate("CreatedDate", "ASC")} style={{ cursor: "pointer", fontWeight: orderBy === "CreatedDate" ? "bold" : ""}}>Created Date<ArrowUpwardOutlinedIcon fontSize="small"/></span> }</TableCell>
              <TableCell align="left">View</TableCell>
              <TableCell align="left">Actions</TableCell>
            
            </TableRow>
          </TableHead>
          <TableBody>
            { search_list && search_list.length > 0 && search_list.map((searchs => searchs.length > 0 ? searchs.map(search => (
              <TableRow
                key={search.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">{search.searchname && search.searchname !== null ? search.searchname : "-"}</TableCell>
                <TableCell align="left">{search.searchkeyword && search.searchkeyword !== null ? search.searchkeyword : "-"}</TableCell>
                <TableCell align="left">{search.street && search.street !== null ? search.street : "-"}</TableCell>
                <TableCell align="left">{search.createddate && search.createddate !== null ? moment(search.createddate).format("DD-MMM-YYYY") : "-"}</TableCell>
                <TableCell align="left"> 
                    <Button className="nav_link"  onClick={async()=>{
                    await  setCache("market-search",  { prevPath: "/saved-search", id: search.id, searchName : search.searchname , fromPage : "saved-search"});
                    dispatch({ type: 'developmentFilters', value: [] });
                    navigate("/market-search");
                    }} >View on Map </Button>
                </TableCell>
               
                <TableCell align="right" className="three-dots">
                <MenuItem onClick={(e)=> {
                    handleClickOpen(e , search);
                }} className="delete-option">
                  <DeleteOutlinedIcon />
                </MenuItem>
                </TableCell>
              </TableRow>
            )):( <TableRow>
              <TableCell
                style={{ textAlign: "center" }}
                colSpan="5"
                className="store-no-data"
              >
                No records found
              </TableCell>
            </TableRow>)))}
          </TableBody>
        </Table>
      </TableContainer>
      </div>

      <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          id="snack-success"
          className="snack-bar"
          maxsnack={3}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snack.snackMsg}</span>}
          action={[
            <Clear
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={snackHandleclose}
            />,
          ]}
        />

      <Dialog
        open={openDialog}
        onClose={handleClickClose}
        aria-describedby="alert-dialog-slide-description"
        className="small-info-popup"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose} className="no-btn">No</Button>
          <Button onClick={handleDelete} className="yes-btn">Yes</Button>
        </DialogActions>
      </Dialog>
     
        </InfiniteScroll>
    </div>
  );
};
export default SavedSearchList;
